import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import ContactSection from '../components/ContactSection'

const Contact = () => {
  return (
    <>
    <Helmet>
      <title>Contact Us - Om Softwares | Get a Free Consultation</title>
      <meta name="description" content="Contact Om Softwares for digital marketing, web development, SEO, and social media marketing services. Get a free consultation today. Located in Nangal, Punjab." />
      <meta property="og:title" content="Contact Us - Om Softwares" />
      <meta property="og:description" content="Contact Om Softwares for digital marketing, web development, and SEO services. Get a free consultation today." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/contact" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Contact Us - Om Softwares" />
      <meta name="twitter:description" content="Contact Om Softwares for digital marketing, web development, and SEO services." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <main>
        <Breadcrumb name="Contact Us"/>
        <ContactSection/>
    </main>
    </>
  )
}

export default Contact
